import { render, staticRenderFns } from "./GiftItem.vue?vue&type=template&id=b1cbe178&scoped=true&"
import script from "./GiftItem.vue?vue&type=script&lang=js&"
export * from "./GiftItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftItem.vue?vue&type=style&index=0&id=b1cbe178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cbe178",
  null
  
)

export default component.exports